import React from 'react';
import { Error as ErrorComponent, ErrorComponentProps, LayoutRoute } from '@cko/dashboard-shared';
import '@cko/design-system-themes/core-2023.css';

import { VisualProvider } from '../../../../providers/VisualProvider';

export const Error = (props: ErrorComponentProps) => {
  document.title = 'Home';
  return (
    <VisualProvider>
      <LayoutRoute>
        <ErrorComponent {...props} />
      </LayoutRoute>
    </VisualProvider>
  );
};
